var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundEllepsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 993,
    viewBox: "0 0 1920 993",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_619_157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 993
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 993,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_619_157)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M629.5 71.2407C629.5 332.055 376.974 544.204 64.5 544.204C-247.974 544.204 -500.5 332.055 -500.5 71.2407C-500.5 -189.573 -247.974 -401.722 64.5 -401.722C376.974 -401.722 629.5 -189.573 629.5 71.2407Z",
    stroke: "#002D74",
    strokeOpacity: 0.82,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.5 968.463C530.5 1229.28 277.974 1441.43 -34.5 1441.43C-346.974 1441.43 -599.5 1229.28 -599.5 968.463C-599.5 707.649 -346.974 495.5 -34.5 495.5C277.974 495.5 530.5 707.649 530.5 968.463Z",
    stroke: "#F48400",
    strokeOpacity: 0.3,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 812.686,
    cy: 538.639,
    rx: 812.686,
    ry: 538.639,
    transform: "matrix(0.956018 -0.293309 0.33693 0.94153 632.42 580.074)",
    fill: "#EB7F00",
    fillOpacity: 0.16
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEllepsis);
export default __webpack_public_path__ + "static/media/background_ellepsis.edc4add36c16de20a4e8e1ee1726a560.svg";
export { ForwardRef as ReactComponent };